import React, { useState, lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { map as _map, orderBy as _orderBy, isEmpty as _isEmpty } from 'lodash-es';
import SummeryLoader from 'components/SummeryLoader/SummeryLoader';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './MainSidebar.scss';
import { isBillPlanDesignRequired } from 'utilities/utilities_exports';
import SubmenuSection from './SubmenuSection/SubmenuSection';

const MainSidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const merchantData = useSelector(state => state?.User?.accountDetails);
  const navigationMenus = useSelector(state => state?.Navigation);
  const subMenus = useSelector(state => state?.Navigation?.subMenu);
  const isDataLakeReady = merchantData?.isDataLakeReady || false;
  const [showMouseState, setShowMouseState] = useState(false);
  const billPlanDetails = useSelector(state => state?.SubscriptionDetails?.billingPlanDetails?.data);
  const isFreeTrail = billPlanDetails?.subscriptionState === 'FREE';
  const pathname = window.location.pathname;
  const overallBillPlanDetails =
    useSelector(state => state?.SubscriptionDetails?.overallBillPlanDetails?.data?.FEATURES) || [];
  const [isBillPlanUIRequired, setIsBillPlanUIRequired] = useState(false);
  const hasWriteAccess = useSelector(state => state?.Account?.hasWriteAccess);

  const scrollbarConfigs = {
    style: { height: 'calc(100% - 72px)' },
    autoHide: true,
    autoHideTimeout: 200,
    autoHideDuration: 200,
    thumbMinSize: 30,
    universal: true
  };

  const sideBarBillPlanUI = () => {
    return (
      <div className='billPlanUIContainer' style={{ background: 'white', marginLeft: -10 }}>
        <div className='upgrade-block'>
          <div
            className='tc-Features'
            style={{ padding: 15, whiteSpace: 'nowrap' }}
            dangerouslySetInnerHTML={{
              __html: t('GRAAS_UPGRADE_TO_PRO_PLAN_TO_UNLOCK_ALL_TURBOCHARGER_FEATURES_GRAAS')
            }}
          ></div>
          <div className='expiry_button_div' style={{ whiteSpace: 'nowrap' }}>
            <button
              className='upgradeBtn'
              onClick={() =>
                navigate(
                  `/pricingDetails?redirectTo=${window.location.href.split(window.location.host)?.[1] || pathname}`
                )
              }
            >
              {' '}
              {t('GRAAS_UPGRADE_GRAAS')}
            </button>{' '}
          </div>
        </div>
      </div>
    );
  };

  return (
    <aside
      className={`c-sidebar ${hasWriteAccess ? '' : 'demoAcc'}`}
      role='button'
      onMouseEnter={() => {
        setIsBillPlanUIRequired(isBillPlanDesignRequired(overallBillPlanDetails, billPlanDetails));
        setShowMouseState(true);
      }}
      onMouseLeave={() => {
        setShowMouseState(false);
      }}
    >
      <Scrollbars
        {...scrollbarConfigs}
        style={{
          height:
            merchantData?.isBillPlanEnabled && isFreeTrail && showMouseState && isBillPlanUIRequired
              ? 'calc(100% - 150px)'
              : '100%'
        }}
      >
        {navigationMenus?.loading && !navigationMenus?.error && (
          <SummeryLoader size='small' dataSectionCount={6} dataSectionHeight={42} />
        )}
        {!navigationMenus?.loading &&
          !navigationMenus?.error &&
          !_isEmpty(subMenus) &&
          _map(_orderBy(subMenus, ['position'], ['asc']), data => (
            <Suspense fallback={<></>} key={data?.sectionHeading}>
              <SubmenuSection data={data} isDataLakeReady={isDataLakeReady} />
            </Suspense>
          ))}
      </Scrollbars>
      <Scrollbars>
        {merchantData?.isBillPlanEnabled && isFreeTrail && showMouseState && isBillPlanUIRequired && (
          <>{sideBarBillPlanUI()}</>
        )}
      </Scrollbars>
    </aside>
  );
};

export default MainSidebar;
